import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const QRCodeWithCopyDownload = ({ text, qr }) => {
    const [copied, setCopied] = useState(false);
    const qrCodeRef = useRef(null);

    const handleCopy = event => {
        event.preventDefault();

        if (!navigator.clipboard) {
            console.error('Clipboard API not supported in this browser.');
            return;
        }

        navigator.clipboard
            .writeText(text)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => {
                console.error('Copy failed. Please try again manually.');
            });
    };

    const handleDownload = event => {
        event.preventDefault();
        const blob = new Blob(
            [Uint8Array.from(atob(qr), char => char.charCodeAt(0))],
            { type: 'image/png' }
        );

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'qr-code.png';

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    return (
        <div className="qr-code-container">
            <div ref={qrCodeRef}>
                <img alt={'STATIC-QR'} src={`data:image/png;base64,${qr}`} />
            </div>
            <p className="qr-code-text">{text}</p>
            <div className="qr-code-buttons">
                <button className="browse-another-btn" onClick={handleCopy}>
                    {copied ? 'Copied!' : 'Copy'}
                </button>
                <button className="upload-btn" onClick={handleDownload}>
                    Download
                </button>
            </div>
        </div>
    );
};

QRCodeWithCopyDownload.propTypes = {
    text: PropTypes.string.isRequired,
    qr: PropTypes.string.isRequired,
};

export default QRCodeWithCopyDownload;
